import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import { AuthErrorBoundary } from './components/AuthErrorBoundary.tsx';
import { SportFilterProvider } from './context/SportFilterContext.tsx';
import { debugLog, logRootInit } from './utils/debugLogger';
import './index.css';

debugLog('MAIN_EXEC', 'src/main.tsx script execution started');

const rootElem = document.getElementById('root');
logRootInit(!!rootElem);

// Update visual mount indicator status
const indicatorTextElem = document.getElementById('mount-indicator-text');
const indicatorElem = document.getElementById('html-mount-indicator');

if (rootElem) {
  if (indicatorTextElem) {
    indicatorTextElem.textContent = 'React Root Initialized • Rendering App';
  }

  debugLog('RENDER_PHASE', 'Calling createRoot and rendering StrictMode > ErrorBoundary > AuthErrorBoundary > SportFilterProvider > App');
  const root = createRoot(rootElem);
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <AuthErrorBoundary>
          <SportFilterProvider>
            <App />
          </SportFilterProvider>
        </AuthErrorBoundary>
      </ErrorBoundary>
    </StrictMode>
  );
  debugLog('RENDER_PHASE_COMPLETE', 'createRoot.render call dispatched successfully');

  if (indicatorTextElem) {
    indicatorTextElem.textContent = 'Playground League Active ✓';
  }

  // Fade out indicator after confirmation delay
  setTimeout(() => {
    if (indicatorElem) {
      indicatorElem.style.opacity = '0';
      setTimeout(() => {
        indicatorElem.remove();
      }, 600);
    }
  }, 3500);
} else {
  if (indicatorTextElem) {
    indicatorTextElem.textContent = 'FATAL ERROR: #root node missing!';
    if (indicatorElem) {
      indicatorElem.style.borderColor = '#f43f5e';
      indicatorElem.style.color = '#f43f5e';
    }
  }
  console.error('[Playground Debug][FATAL] Could not find #root element in index.html!');
}
